<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.cpcode" placeholder="编号" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.cpname" placeholder="名称" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="cpname" label="名称" min-width="120">
				<template slot-scope="scope">
					{{scope.row.cpcode}}:{{scope.row.cpname}}<br/>
					{{scope.row.entime}}
				</template>
			</el-table-column>
			<el-table-column prop="url" label="同步接口" min-width="250">
				<template slot-scope="scope">
					成功URL:{{scope.row.url}}<br/>
					失败URL:{{scope.row.err_url}}
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item label="编号" prop="cpcode">
					<el-input v-model="editForm.cpcode" placeholder="编号" @blur="inputExtend"></el-input>
					<el-tag effect="dark" v-if="checkInSpService" type="danger">存在此代码请更改!</tag>
				</el-form-item>
				<el-form-item label="名称" prop="cpname">
					<el-input v-model="editForm.cpname" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="同步接口" prop="url">
					<el-input v-model="editForm.url" placeholder="同步接口" type="textarea" :row="25"></el-input>
				</el-form-item>
				<el-form-item label="错误接口" prop="err_url">
					<el-input v-model="editForm.err_url" placeholder="错误数据接口" type="textarea" :row="25"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					cpcode:'',cpname:''
				},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					cpcode :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					cpname :[
						{required: true,message: '名称不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',cpcode:'',cpname:'',url:'',err_url:''
				},
				checkInSpService:false
			}
		},
		methods: {
			inputExtend(){
				if(this.editForm.cpcode=='') return ;
				this.editLoading = true ;
				//检测代码是否存在
				let para = {
					actionurl:'default/getListAll',
					cpcode:this.editForm.cpcode,
					checkId:this.editForm.id,
					sqlid:'sp_cpinfo.checkQuery'
				};
			
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						if(res.data.total>0) this.checkInSpService = true ;//存在
						else this.checkInSpService = false ;
					}
					this.editLoading = false;
				});
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					cpcode:this.filters.cpcode,
					cpname:this.filters.cpname,
					sqlid:'sp_cpinfo.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'sp_cpinfo.add',entime:'',cpcode:'',cpname:'',url:'',err_url:''
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'sp_cpinfo.upt';
			},
			editSubmit:function(){
				//检测代码是否存在
				if(this.checkInSpService) {
					this.$message({message: "代码重复，不可提交!",type: "error"});
					return ;
				}
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					let para = {
						actionurl:'default/getListAll',
						cpcode:row.cpcode,
						sqlid:'sp_service.query'
					};
					getListPage(para).then((res) => {
						if(!util.checkLogOut(this,res.data)){
							if(res.data.total>0) {
								this.$message({message: "此渠道被代码使用，暂不可删除!",type: "error"});
							}
							else {
								this.$message({message: "检测到此渠道未被使用，正在删除中!",type: "success"});
								this.listLoading = true;
								let para = {
									actionurl:'default/del',
									sqlid:'sp_cpinfo.del',
									id:row.id
								};
								delData(para).then((res) => {
									this.listLoading = false;
									this.$message({message: res.data.message,type: res.data.type});
									this.getLists();
								});
							}
						}
						this.editLoading = false;
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// cpinfo.vue?6b2f032d